import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { LoadNewPlans } from "../../actions";
import { RefreshCircleIcon } from "../../icon";
import { Plan, PlanType } from "../../models/plans.model";
import * as selector from "../../selectors/selectors";
import ButtonComponent from "../shared/button/button.component";
import { appNote } from "../shared/constants";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TierLoader from "../shared/loaders/tiers-loader.json";
import NewAddOnCard from "../new-subscription-flow/NewAddonCard";

interface IProps {
    HandleNext?: (data: { Plan: Plan, Tenure: string, Count: number }) => void;
    Stepdata?: any;
}

const NewSelectAddon = (props: IProps) => {
    const { state } = useLocation();
    const dispatch = useDispatch();

    const NewPlans: Plan[] = useSelector(selector.newPlans)
    const LoadingNewPlans: boolean = useSelector(selector.loadingNewPlans)

    const [filterPlans, setFilterPlans] = useState<Plan[]>([])
    const [selectSheet, setSelectedSheet] = useState<Array<{ id: string, count: number, isTouched: boolean }>>([]);
    const [tenure, setTenure] = useState<number>((!props.Stepdata?.planHistory?.length || props.Stepdata?.planHistory[0].IsYearPlan === true || state.Organization?.IsYearPlan === null) ? 1 : 2);

    useEffect(() => {
        LoadNewPlans(dispatch)
    }, [])

    useEffect(() => {
        setFilterPlans(NewPlans.filter(x => !x.IsDeleted && x.PlanType === PlanType.ADD_ON))
    }, [NewPlans])

    const onSelectionChange = (id: string, count: number) => {
        const existing = selectSheet?.find(x => x.id === id);
        if (existing) {
            if (count === 0) {
                setSelectedSheet(selectSheet.map(x => x.id === id ? { ...x, count: count, isTouched: false } : x).filter(x => x.count > 0));
            }
            else {
                setSelectedSheet(selectSheet.map(x => x.id === id ? { ...x, count: count, isTouched: true } : x));
            }
        } else {
            setSelectedSheet([...selectSheet, { id, count: count, isTouched: true }]);
        }
    }

    const handleconfirm = () => {
        const selectedPlansWithDetails = selectSheet.filter((x) => x.isTouched).map(sheet => {
            const planDetails = NewPlans.find(plan => plan.Id === sheet.id);
            return {
                Plan: planDetails,
                Count: sheet.count
            };
        }).filter(x => x.Plan);

        if (selectedPlansWithDetails.length === 1) {
            props.HandleNext({
                Plan: selectedPlansWithDetails[0].Plan,
                Tenure: tenure === 1 ? "A" : "M",
                Count: selectedPlansWithDetails[0].Count
            });
        };
    }


    return (<Grid container className=" ml-2 mr-2 h-v-80 paper-background  dialogue-shadow settings-paper-border br-4">
        <Grid container direction="row" className={`mx-0 d-flex justify-center align-center h-p-80 o-y-scroll o-x-hidden`} >
            {
                LoadingNewPlans ?
                    <Grid xl={3} lg={3} md={6} sm={8} item className='my-2 mx-4'>
                        <AnimateLoader LoaderAnimation={TierLoader} style={{ maxWidth: "330px" }} className={"w-p-100"} />
                    </Grid>
                    : filterPlans?.length > 0 ?
                        filterPlans?.length > 0 ? filterPlans?.map((plan, i) =>
                            <Grid item>
                                <NewAddOnCard
                                    key={i}
                                    Plan={plan}
                                    HideBuyNow={true}
                                    ShowAddOnOptions={false}
                                    Index={(i + 1) % 2 === 0}
                                    EnableCounter={selectSheet.filter(x => x.id === plan.Id && x.isTouched)?.length > 0}
                                    PlanSelected={selectSheet.filter(x => x.isTouched)?.length > 0}
                                    OnSelectionChange={(count) => { onSelectionChange(plan.Id, count) }}
                                    SelectionCount={selectSheet.find(x => x.id === plan.Id && x.isTouched)?.count}
                                />
                            </Grid>
                        )
                            :
                            <span className="h3-regular">{appNote.NO_ADDONS_AVAILABLE}</span>
                        : <div className="c-pointer" onClick={() => LoadNewPlans(dispatch)}>
                            <div className="d-flex">
                                <RefreshCircleIcon className="mx-auto" />
                            </div>
                            <div className="h4 mt-1">{appNote.CLICK_TO_REFRESH_PLANS}</div>
                        </div>
            }
        </Grid>
        <Grid container direction="row" className="d-flex justify-end align-center" justifyContent="flex-end">
            {
                filterPlans?.length > 0 && filterPlans?.length > 0 &&
                <ButtonComponent
                    ButtonLabel={"Next"}
                    OnClick={() => handleconfirm()}
                    Variant={selectSheet.filter(x => x.isTouched)?.length < 1 ? "disabled-btn" : "primary-btn"} ClassName="mr-3" />
            }
        </Grid>
    </Grid >
    )
};

export default NewSelectAddon;

